import React from "react";
import "./logo.scss";
const Logo = () => {
  return (
    <div>
      <h1 className="logo" id="logo">
        MIMIE BAKES.
      </h1>
    </div>
  );
};

export default Logo;
